// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"964":"0de8bc92","5724":"80c7e5b3","6772":"50cde873","7314":"289026f1","7926":"6311d424","8204":"e35176d5","8728":"50cde873","9695":"f1f552c8"}[chunkId] + ".chunk.css";
};